import styles from './close-button.module.scss';
import { WideWidgetStyle } from '../wide/wide-widget-style';
import EventEmitter from '../../event-emitter.model';

export default class CloseButton {
	constructor(className:WideWidgetStyle='default') {
		this.element.className = styles[className];
		this.element.dataset.nameSpace = 'dentolo';

		this.element.onclick = (e) => {
			this.eventEmitter.emit("click", e);
		}
	}

	public element:HTMLDivElement = document.createElement('div');
	private eventEmitter = new EventEmitter();

	public onClick(callback:(event:MouseEvent)=>void) {
		return this.eventEmitter.subscribe("click", callback);
	}
}